<template>
  <el-dialog
    :title="'退款详情 (' + refundData.dateRange + ')'"
    :visible.sync="visible"
    width="1200px"
    top="5vh"
    :before-close="handleClose"
    @close="handleClose">

    <!-- 数据表格 - 父子表格结构 -->
    <el-table
      ref="table"
      :data="tableData"
      border
      style="width: 100%; margin-top: 10px;"
      v-loading="loading"
      :row-key="getRowKey"
      :expand-row-keys="expandedRows"
      @expand-change="handleExpandChange">

      <!-- 展开行 - 显示退款明细信息 -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div class="refund-items-section">
            <div v-if="scope.row.itemsLoading" style="text-align: center; padding: 20px;">
              <i class="el-icon-loading"></i> 加载中...
            </div>
            <el-table v-else :data="scope.row.refundItems" border style="width: 100%;">
              <el-table-column prop="itemImage" label="商品图片" width="100" align="center">
                <template slot-scope="item">
                  <img :src="item.row.itemImage || '/static/img/default-product.png'"
                    style="width: 55px; height: 55px; object-fit: cover; border-radius: 4px;"
                    @error="handleImageError" />
                </template>
              </el-table-column>
              <el-table-column prop="itemName" label="商品名称" min-width="300" align="center">
                <template slot-scope="item">
                  <span class="item-name-text clickable-item-name"
                        @click="copyItemName(item.row.itemName)"
                        :title="'点击复制商品名称: ' + item.row.itemName">
                    {{ item.row.itemName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="数量" width="80" align="center"></el-table-column>
              <el-table-column prop="purchaseAmount" label="采购金额" width="100" align="center">
                <template slot-scope="item">
                  <span> 
                    {{ formatAmount(item.row.purchaseAmount) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="applyAmount" label="申请退款金额" width="120" align="center">
                <template slot-scope="item">
                  <span> 
                    {{ formatAmount(item.row.applyAmount) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="refundSuccessAmount" label="成功退款" width="100" align="center">
                <template slot-scope="item">
                  <span style="color: #A1C65C; font-weight: bold;">
                    {{ formatAmount(item.row.refundSuccessAmount) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="resultTime" label="填写时间" width="140" align="center">
                <template slot-scope="item">
                  {{ formatDate(item.row.resultTime) }}
                </template>
              </el-table-column>
              <el-table-column prop="settlementFlag" label="结算状态" width="140" align="center">
                <template slot-scope="item">
                  <span v-if="item.row.settlementFlag === '0'">
                    <el-tag type="warning">待结算</el-tag>
                  </span>
                  <span v-else-if="item.row.settlementFlag === '1'">
                    <el-tag type="success">已结算</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="info">无需结算</el-tag>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>

      <!-- 父表格字段 -->
      <el-table-column prop="shopName" label="店铺名称"  min-width="100" align="center" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="orderSn" label="订单号" min-width="100" align="center">
        <template slot-scope="scope">
          <span style="color: #409EFF; font-weight: bold; cursor: pointer;"
            @click="copyOrderSn(scope.row.orderSn)"
            :title="'点击复制订单号'">
            {{ scope.row.orderSn }}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="下单时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>

      <!-- 备注列 -->
      <NoteColumn :current-scene="currentScene" width="300" />

      <!-- <el-table-column label="操作" min-width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="openNotesDrawer(scope.row)" icon="el-icon-tickets">备注</el-button>
        </template>
      </el-table-column> -->

    </el-table>

    <!-- 总记录数显示 -->
    <div class="total-records">
      共 {{ pageParam.total }} 条记录， 总金额：<span class="total-amount">￥{{ totalAmount.toFixed(2) }}</span>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">关闭</el-button>
    </span>

    <!-- 备注抽屉 -->
    <el-drawer
      title="订单备注"
      :visible.sync="notesDrawerVisible"
      direction="rtl"
      size="600px"
      :before-close="handleDrawerClose">
      <div style="padding: 20px;">
        <OrderNotesDrawer
          :notes="currentOrderNotes"
          :orderSn="currentOrderSn"
          :currentScene="currentScene"
          :showDebug="false"
          @note-updated="handleNoteUpdated" />
      </div>
    </el-drawer>
  </el-dialog>
</template>

<script>
import { getOrdRefundNestedPage } from '../../api/OrdRefund'
import NoteColumn from '../../components/NoteColumn'
import OrderNotesDrawer from '../order/OrderNotesDrawer'
import copyMixin from '../../mixins/copyMixin'
import noteDrawerMixin from '../../mixins/noteDrawerMixin'

export default {
  name: 'StlRefundView',
  mixins: [copyMixin, noteDrawerMixin],
  components: {
    NoteColumn,
    OrderNotesDrawer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    refundData: {
      type: Object,
      default: () => ({
        week: 1,
        dateRange: '',
        amount: 0,
        userId: null,
        year: null,
        month: null
      })
    }
  },
  data() {
    return {
      tableData: [],
      loading: false,
      totalAmount: 0,
      // 分页数据
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 搜索表单数据
      formInline: {
        current: 1,
        size: 10,
        resultUserId: null,  // 改为按处理人查询，与后端统计逻辑一致
        resultStatus: '1', // 只查询退款成功的记录
        settlementFlagList: ['0', '1'] // 只查询待结算和已结算的记录，排除无需结算(-1)的记录
      },
      currentScene: '05',  // 已采购但出库前取消
      expandedRows: []  // 展开的行
    }
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadRefundData()
      } else {
        this.resetData()
      }
    }
  },
  methods: {
    async loadRefundData() {
      if (!this.refundData.userId || !this.refundData.year || !this.refundData.month || !this.refundData.week) {
        return
      }

      this.loading = true
      try {
        const params = {
          ...this.formInline,
          // 覆盖分页，确保详情统计拿到本周所有记录
          current: 1,
          size: 100000,
          resultUserId: this.refundData.userId,  // 改为按处理人查询
          // 添加时间范围过滤，确保只查询该周的数据
          resultTimeStart: this.calculateWeekDates().startDate.split(' ')[0],
          resultTimeEnd: this.calculateWeekDates().endDate.split(' ')[0],
          // 只查询待结算和已结算的记录
          settlementFlagList: ['0', '1']
        }

        const response = await getOrdRefundNestedPage(params)
        if (response.success && response.data) {
          // 后端已经按时间范围和处理人过滤了数据，直接使用
          const allData = response.data.records || []

          // 过滤每个订单的退款明细，只保留settlement_status为0或1的记录
          this.tableData = allData.map(order => ({
            ...order,
            refundItems: (order.refundItems || []).filter(item =>
              item.settlementFlag === '0' || item.settlementFlag === '1'
            )
          })).filter(order => order.refundItems && order.refundItems.length > 0) // 只保留有符合条件明细的订单

          this.pageParam.total = this.tableData.length
          this.pageParam.currentPage = 1
          this.pageParam.pageSize = 10

          // 计算总金额
          this.calculateTotalAmount()
        } else {
          this.$message.error('获取退款数据失败')
        }
      } catch (error) {
        console.error('加载退款数据失败:', error)
        this.$message.error('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },

    calculateWeekDates() {
      // 根据年、月、周计算该周的开始和结束日期
      const year = this.refundData.year
      const month = this.refundData.month
      const week = this.refundData.week

      // 获取该月第一天
      const firstDay = new Date(year, month - 1, 1)
      const firstDayOfWeek = firstDay.getDay() // 0是周日，1是周一

      // 计算第一周的开始日期（从周一开始）
      const firstMondayDate = new Date(firstDay)
      if (firstDayOfWeek === 0) {
        // 如果第一天是周日，则往前推6天到周一
        firstMondayDate.setDate(firstDay.getDate() - 6)
      } else if (firstDayOfWeek !== 1) {
        // 如果第一天不是周一，则往前推到周一
        firstMondayDate.setDate(firstDay.getDate() - (firstDayOfWeek - 1))
      }

      // 计算指定周的开始日期
      const weekStartDate = new Date(firstMondayDate)
      weekStartDate.setDate(firstMondayDate.getDate() + (week - 1) * 7)

      // 计算指定周的结束日期
      const weekEndDate = new Date(weekStartDate)
      weekEndDate.setDate(weekStartDate.getDate() + 6)
      weekEndDate.setHours(23, 59, 59, 999)

      return {
        startDate: this.formatDateForAPI(weekStartDate),
        endDate: this.formatDateForAPI(weekEndDate)
      }
    },

    formatDateForAPI(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    filterDataByWeek(allData) {
      if (!allData || allData.length === 0) return []

      // 计算该周的开始和结束日期
      const { startDate, endDate } = this.calculateWeekDates()
      const startTime = new Date(startDate).getTime()
      const endTime = new Date(endDate).getTime()

      return allData.filter(item => {
        if (!item.resultTime) return false
        const resultTime = new Date(item.resultTime).getTime()
        return resultTime >= startTime && resultTime <= endTime
      })
    },

    calculateTotalAmount() {
      this.totalAmount = this.tableData.reduce((total, order) => {
        const orderTotal = (order.refundItems || []).reduce((orderSum, item) => {
          return orderSum + (item.refundSuccessAmount || 0)
        }, 0)
        return total + orderTotal
      }, 0)
    },

    resetData() {
      this.tableData = []
      this.totalAmount = 0
      this.pageParam = {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
      this.formInline.current = 1
      this.formInline.resultUserId = null
    },



    // 格式化金额，添加千分位逗号
    formatAmount(amount) {
      if (!amount && amount !== 0) return '-'
      const num = parseFloat(amount)
      if (isNaN(num)) return '-'
      return '￥ ' + num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return '-'
      const dateObj = new Date(date)
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      const hours = String(dateObj.getHours()).padStart(2, '0')
      const minutes = String(dateObj.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },

    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 获取行key
    getRowKey(row) {
      return row.orderSn
    },

    // 展开行变化
    handleExpandChange(row, expandedRows) {
      this.expandedRows = expandedRows.map(r => r.orderSn)
      // 退款明细已经在loadRefundData中加载，无需额外加载
    },



    // 复制到剪贴板
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('已复制到剪贴板')
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text)
        })
      } else {
        this.fallbackCopyTextToClipboard(text)
      }
    },

    // 兼容性复制方法
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textArea)
    },

    // 复制快递号
    copyExpressNo(expressNo) {
      this.copyToClipboard(expressNo)
    },

    // 复制订单号
    copyOrderSn(orderSn) {
      this.copyToClipboard(orderSn)
    },



    // 处理图片加载错误
    handleImageError(event) {
      event.target.src = '/static/img/default-product.png'
    }
  }
}
</script>

<style scoped>
.refund-detail-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.refund-detail-header h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.total-amount-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.total-label {
  color: #666;
  font-size: 14px;
}

.total-amount {
  color: #409EFF;
  font-weight: bold;
  font-size: 18px;
}

.dialog-footer {
  text-align: center;
}

.total-records {
  text-align: center;
  margin: 15px 0;
  color: #666;
  font-size: 14px;
}

/* 订单项展开区域样式 */
.order-items-section {
  padding: 10px 20px;
  background-color: #fafafa;
  border-radius: 4px;
  margin: 10px 0;
}

.order-items-section .el-table {
  margin-top: 10px;
}

.order-items-section .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 500;
}

/* 快递号样式 */
.express-no {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
}

.express-no:hover {
  color: #66b1ff;
}

.no-express {
  color: #c0c4cc;
  font-style: italic;
}

.clickable-express {
  transition: color 0.3s;
}

/* 商品名称复制样式 */
.clickable-item-name {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-item-name:hover {
  opacity: 0.8;
  transform: scale(1.02);
}
</style>



// WEBPACK FOOTER //
// src/views/stl/StlRefundView.vue